import { __decorate } from "tslib";
import { registerDecorator, ValidatorConstraint } from "class-validator";
export function DependsOn(property, validationOptions) {
    return (object, propertyName) => {
        registerDecorator({
            target: object.constructor,
            propertyName,
            options: validationOptions,
            constraints: [property],
            validator: DependsOnConstraint,
        });
    };
}
let DependsOnConstraint = class DependsOnConstraint {
    validate(value, args) {
        return true;
    }
    defaultMessage(args) {
        return "";
    }
};
DependsOnConstraint = __decorate([
    ValidatorConstraint({ name: "dependsOn" })
], DependsOnConstraint);
export { DependsOnConstraint };
//# sourceMappingURL=DependsOn.js.map